export type Family = 'ask' | 'show' | 'act' | 'flow' | 'escalate';

export const SPECIAL_TARGETS = ['next', 'continue', 'break', 'end'] as const;
export type SpecialTarget = typeof SPECIAL_TARGETS[number];

export const STEP_ID_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;
export const VARIABLE_PATTERN = /^(?!__)[A-Za-z_][A-Za-z0-9_]*$/;
export const SKILL_NAME_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const DOC_REF_PATTERN = /^doc:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const CONNECTION_PATTERN = /^(workspace|personal):[a-z0-9_-]+$/;
export const MAX_REPEAT = 500;

export interface ConditionBranch {
  when: string;
  goto: string;
}

export interface OtherwiseBranch {
  otherwise: string;
}

export type Branch = ConditionBranch | OtherwiseBranch;

export type Next = string | Branch[] | Record<string, string>;

export interface Step {
  id: string;
  type: string;
  title?: string;
  next?: Next;
  steps?: Step[];
  [field: string]: unknown;
}

export interface Section {
  id: string;
  title: string;
  steps: Step[];
}

export type VariableType = 'text' | 'number' | 'boolean';

export interface VariableDef {
  type: VariableType;
  unit?: string;
  source?: string;
}

export interface Workflow {
  variables: Record<string, VariableDef>;
  sections: Section[];
}

export type Severity = 'error' | 'warning';

export type IssueCode =
  | 'bad_frontmatter'
  | 'bad_yaml'
  | 'bad_structure'
  | 'multiple_workflow_blocks'
  | 'empty_workflow'
  | 'duplicate_id'
  | 'unknown_type'
  | 'missing_field'
  | 'bad_field'
  | 'unknown_field'
  | 'bad_branch'
  | 'bad_expression'
  | 'unknown_target'
  | 'target_outside_loop'
  | 'target_crosses_loop'
  | 'undeclared_variable'
  | 'empty_repeat'
  | 'unreachable'
  | 'falls_into_branch'
  | 'unset_variable'
  | 'same_answers'
  | 'bad_source'
  | 'missing_media'
  | 'connection_unavailable'
  | 'unknown_workflow';

export interface Issue {
  severity: Severity;
  code: IssueCode;
  message: string;
  stepId?: string;
  field?: string;
}
